module.exports = __webpack_public_path__ + "img/Smart-Rooms.c9459ed8.png";